const namespaced = true;

const state = {
  items: []
};

const getters = {
  items: state => state.items
};

const mutations = {
  SET_ITEM: (state, payload) => {
    state.items = payload;
  }
};

const actions = {
  async fetchList({ commit }) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/user/parent/student`);
      commit('SET_ITEM', data);
      return Promise.resolve(data);
    } catch (err) {
      throw err;
    }
  }
};

export default { namespaced, state, getters, mutations, actions };
